/**
 * @description 防止CSV注入
 */

define('filters/appmng/csv-injection.filter',['app'], function (app) {
    app.filter('csvInjectionFilter', function () {
        return function (input) {
            var param = !input ? '' : input;
            return AUI.BaseJSUtil.handleCSVFilter(param);
        };
    });
});

